export const brand = {
  name: 'Octubre con María',
  eyebrow: '31 días junto a María',
  headline: 'Octubre puede ser el mes para',
  headlineAccent: 'volver a hacer espacio para Dios',
  subtitle:
    'Vive 31 días junto a María con oraciones, reflexiones y pequeños propósitos para cada día.',
  supporting:
    'Un camino espiritual sencillo para vivir el Mes del Rosario con más intención, incluso en medio de la rutina.',
  descriptor: '31 días guiados + Guía Práctica del Rosario',
  mockupCaption: 'Octubre con María: 31 días guiados + Guía Práctica del Rosario',
  tagline: '31 días para rezar, reflexionar y caminar junto a María.',
}

export const ctaLabels = {
  primary: 'Quiero comenzar Octubre con María',
  withPrice: 'Quiero Octubre con María por USD 9,99',
}

export const heroBadges: string[] = [
  'Acceso inmediato',
  'Formato digital',
  'Puedes imprimirlo',
  'Acceso de por vida',
]

export interface DailyMoment {
  emoji: string
  title: string
  text: string
}

export const dailyMoments: DailyMoment[] = [
  { emoji: '🙏', title: 'Una oración', text: 'Un momento para detenerte y hablar con Dios.' },
  { emoji: '🌹', title: 'Una reflexión', text: 'Una lectura breve para acompañar tu día.' },
  {
    emoji: '✨',
    title: 'Un pequeño propósito',
    text: 'Una acción sencilla para llevar la reflexión a tu vida.',
  },
]

export const painPoints: string[] = [
  'Quieres rezar más, pero la rutina termina ocupando todo tu día.',
  'Te gustaría acercarte nuevamente al Rosario, pero no sabes por dónde comenzar.',
  'Comienzas con intención, pero te cuesta mantener la constancia.',
  'Quieres dedicarle unos minutos a Dios sin tener que preparar algo diferente cada día.',
  'Buscas una guía sencilla que puedas seguir desde tu celular.',
]

export interface DayExample {
  day: string
  title: string
}

export const dayExamples: DayExample[] = [
  { day: 'Día 1', title: 'Abre el corazón' },
  { day: 'Día 2', title: 'Confía un poco más' },
  { day: 'Día 3', title: 'Aprende a esperar' },
  { day: 'Día 4', title: 'Entrega tus preocupaciones' },
  { day: 'Día 5', title: 'Haz espacio para Dios' },
]

export interface GalleryItem {
  image: string
  alt: string
}

export const gallery: GalleryItem[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/7vNb7Voqf1FD43sUrM93S5/Captura_de_pantalla_2026-10-01_a_la(s)_12.22.30_a._m..png',
    alt: 'Día 1 — Entrego lo que no puedo controlar: Palabra del día, Junto a María y En el Rosario',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/62K4LC91XctTuN3cPKusPW/Captura_de_pantalla_2026-10-01_a_la(s)_12.22.39_a._m..png',
    alt: 'Día 2 — No necesito tener todas las respuestas: oración, mi entrega de hoy y pequeño propósito',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/hYThC3vrmegME17qYEVS3c/Captura_de_pantalla_2026-10-01_a_la(s)_12.22.48_a._m..png',
    alt: 'Día 3 — Dios también está en lo pequeño: Palabra del día, Junto a María y En el Rosario',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/fxguPSTFWWUxxwVc8vBKrh/Captura_de_pantalla_2026-10-01_a_la(s)_12.23.07_a._m..png',
    alt: 'Día 4 — Cuando aparece el miedo: Palabra del día, Junto a María y En el Rosario',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/uyGo6fyZkCAK2gLM3NkNcq/Captura_de_pantalla_2026-10-01_a_la(s)_12.23.33_a._m..png',
    alt: 'Guía Práctica del Rosario: mapa visual para rezarlo paso a paso',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/piENGg9pHbWHsWiPKt3vZx/Captura_de_pantalla_2026-10-01_a_la(s)_12.23.42_a._m..png',
    alt: 'Oraciones del Rosario: Señal de la Cruz, Credo, Padre Nuestro, Ave María, Gloria y Salve',
  },
]

export const rosaryBonus = {
  eyebrow: 'Incluido',
  title: 'Guía Práctica del Santo Rosario',
  text: 'También recibirás una guía sencilla para acompañarte si quieres comenzar a rezar el Rosario o tener siempre el paso a paso a mano.',
  points: [
    'Cómo rezar el Rosario paso a paso',
    'Misterios del Rosario',
    'Oraciones principales',
    'Intenciones',
    'Una estructura sencilla para acompañar tu oración',
  ],
  badge: 'Incluida sin costo adicional',
  image: 'https://cdn.magicpatterns.com/uploads/fevqRb8m9mAWr2JBxtw5gU/image.png',
}

export interface OfferInclude {
  emoji: string
  label: string
}

export const offerIncludes: OfferInclude[] = [
  { emoji: '🌹', label: '31 días guiados junto a María' },
  { emoji: '🙏', label: 'Reflexiones y oraciones diarias' },
  { emoji: '✨', label: 'Pequeños propósitos para cada día' },
  { emoji: '📿', label: 'Guía Práctica del Santo Rosario' },
  { emoji: '📱', label: 'Acceso digital inmediato' },
]

export const closingLines: OfferInclude[] = [
  { emoji: '🌹', label: 'Un día a la vez.' },
  { emoji: '🙏', label: 'Una oración a la vez.' },
  { emoji: '📿', label: 'Junto a María.' },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cuándo recibo el material?',
    answer: 'El acceso es inmediato después de confirmar tu pago.',
  },
  {
    question: '¿Tengo que comenzar el 1 de octubre?',
    answer: 'No. Puedes comenzar cuando quieras y avanzar a tu propio ritmo.',
  },
  {
    question: '¿Qué incluye Octubre con María?',
    answer:
      'Recibes los 31 días guiados con reflexiones, oraciones y pequeños propósitos, además de la Guía Práctica del Santo Rosario.',
  },
  {
    question: '¿Necesito saber rezar el Rosario?',
    answer: 'No. La guía incluida explica el paso a paso para que puedas seguirlo fácilmente.',
  },
  {
    question: '¿Puedo verlo desde el celular?',
    answer: 'Sí. El material es digital y puedes consultarlo desde celular, tablet o computadora.',
  },
  {
    question: '¿Puedo imprimirlo?',
    answer: 'Sí. Puedes imprimirlo si prefieres utilizarlo en papel.',
  },
  {
    question: '¿El acceso es de por vida?',
    answer:
      'Sí. Una vez adquirido, el material será tuyo para que puedas volver a utilizarlo cuando quieras.',
  },
  {
    question: '¿Es una suscripción?',
    answer: 'No. Es un único pago de USD 9,99.',
  },
]

export const checkoutUrl = 'https://maria.impultienda.ar'

export interface Offer {
  eyebrow: string
  name: string
  subtitle: string
  listPrice: string
  price: string
  priceValue: number
}

export const offer: Offer = {
  eyebrow: 'Oferta especial',
  name: 'Octubre con María',
  subtitle: '31 días de reflexiones, oraciones y pequeños propósitos',
  listPrice: 'USD 19,99',
  price: 'USD 9,99',
  priceValue: 9.99,
}

export const footerLinks: { label: string; href: string }[] = [
  { label: 'Términos de servicio', href: '#planes' },
  { label: 'Política de privacidad', href: '#planes' },
  { label: 'Política de reembolso', href: '#planes' },
  { label: 'Contacto', href: '#planes' },
]

export const heroImage = 'https://cdn.magicpatterns.com/uploads/294z4BHSsLrEphQNRmg9xU/mockup-virgen.png'

export interface PurchaseNotice {
  name: string
  city: string
  product: string
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Camila R.', city: 'Lima', product: 'Octubre con María' },
  { name: 'Andrés B.', city: 'Medellín', product: 'Octubre con María' },
  { name: 'Sofía D.', city: 'Guadalajara', product: 'Octubre con María' },
]
